import { render, staticRenderFns } from "./SubCom3.vue?vue&type=template&id=1a78d7bc&scoped=true"
import script from "./SubCom3.vue?vue&type=script&lang=js"
export * from "./SubCom3.vue?vue&type=script&lang=js"
import style0 from "./SubCom3.vue?vue&type=style&index=0&id=1a78d7bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a78d7bc",
  null
  
)

export default component.exports